import { useState as w, useEffect as u } from "react";
const v = (t = "footer", o = 20) => {
  const [r, i] = w(!1);
  return u(() => {
    if (typeof document > "u") return;
    const e = () => {
      const n = document.querySelector(t);
      if (!n) return;
      const s = n.getBoundingClientRect(), c = window.innerHeight, d = s.top;
      i(d <= c + o);
    };
    return e(), window.addEventListener("scroll", e), window.addEventListener("resize", e), () => {
      window.removeEventListener("scroll", e), window.removeEventListener("resize", e);
    };
  }, [t, o]), { isFooterInView: r };
};
export {
  v as u
};
